/** Bloco azul com o total da coleção e a arte dos três primeiros selos (SEL-04). */
export default function HeroDaColecao({ total, artes }: { total: number; artes: string[] }) {
  return (
    <div className="flex flex-wrap items-center gap-9 rounded-jj-xl bg-brand-blue px-6 py-7 text-brand-white md:px-8">
      <div className="flex min-w-0 flex-[1_1_260px] flex-col gap-3.5">
        <div className="flex items-end gap-3">
          <span className="font-display text-[54px] font-extrabold leading-[0.9] text-brand-yellow">{total}</span>
          <span className="pb-1.5 font-display text-xl font-bold leading-[1.2]">
            selos
            <br />
            conquistados
          </span>
        </div>
        {/* Branco pleno, e não a 92% do design: 4,38:1 sobre o azul (WCAG 1.4.3). */}
        <p className="m-0 max-w-[420px] text-sm leading-[1.45]">
          Cada selo registra o ciclo em que foi conquistado e fica disponível para download e compartilhamento.
        </p>
      </div>

      {artes.length > 0 && (
        <div aria-hidden="true" className="flex shrink-0 items-center">
          {artes.map((arte, indice) => (
            <img
              key={indice}
              src={arte}
              alt=""
              className={`relative h-[104px] w-[104px] object-contain ${indice > 0 ? '-ml-[22px]' : ''}`}
              style={{ zIndex: artes.length - indice }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
